function UserEdit() {
    return (
        <h1>User Edit Page</h1>
    )
}

export default UserEdit;